import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import CreateQuantityMatrixModal from '../component/CreateQuantityMatrixModal';
import UpdateQuantityMatrixModal from '../component/UpdateQuantityMatrixModal';
import * as actions from '../action';
import * as c from '../constant';

function QuantityMatrixCalculation({
  newOtherFeesId,
  quantityMatrixCalculationList,
  getQuantityMatrixCalculationList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getQuantityMatrixCalculationList(newOtherFeesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getQuantityMatrixCalculationList(newOtherFeesId);
  }, [newOtherFeesId]);

  const handleAddQuantityMatrixModal = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <CreateQuantityMatrixModal
          newOtherFeesId={newOtherFeesId}
          quantityMatrixCalculationList={quantityMatrixCalculationList}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Quantity Matrix',
      modalSize: 'modal-md',
    });
  };

  const handleEditQuantityMatrixModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateQuantityMatrixModal
          newOtherFeesId={newOtherFeesId}
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
          quantityMatrixCalculationList={quantityMatrixCalculationList}
        />
      ),
      title: 'Update Quantity Matrix',
      modalSize: 'modal-md',
    });
  };

  return (
    <div>
      <div className="p-3">
        <div className="ml-auto text-right mb-3">
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4 ml-auto"
            onClick={handleAddQuantityMatrixModal}
          >
            Add Quantity Matrix Calculation
          </button>
        </div>
        <table className="transaction-table table table-bordered table-sm table-striped table-hover">
          <thead>
            <tr>
              <td>Unit</td>
              <td>Capacity</td>
              <td>Amount</td>
              <td className="text-center">Action</td>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(quantityMatrixCalculationList) ? (
              quantityMatrixCalculationList.map((item) => (
                <tr key={item.id} className="top-border">
                  <td className="text-left">
                    {_.get(item, 'attributes.unit')}
                  </td>
                  <td className="text-left">
                    {_.get(item, 'attributes.capacity')}
                  </td>
                  <td className="text-left">
                    {_.get(item, 'attributes.amount_human')}
                  </td>
                  <td className="text-right">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEditQuantityMatrixModal(item)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

QuantityMatrixCalculation.propTypes = {
  quantityMatrixCalculationList: PropTypes.instanceOf(Object).isRequired,
  getQuantityMatrixCalculationList: PropTypes.instanceOf(Function).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  quantityMatrixCalculationList:
    _.get(api, `${c.GET_QUANTITY_MATRIX_CALCULATION_LIST}.list`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(QuantityMatrixCalculation);